import React, { useState } from 'react';
import {
  Avatar,
  Box,
  List,
  ListItem,
  Drawer,
  Card,
  CardContent
} from '@mui/material';
import CloseIcon from '../../assets/images/close_icon.svg';
import styles from './Notification.module.css';
import { getImage } from '../../Services/Utils/FileApis';
import { fromEpochToDateWithMonthName } from '../../Services/config/globals';
import ButtonMailTo from '../ButtonMailTo';

export default function Notification({ user, unreadCount }) {
  const [notificationOpenStatus, setNotificationOpenStatus] = useState(false);

  const toggleSlider = () => {
    setNotificationOpenStatus(!notificationOpenStatus);
  };

  const sideList = () => (
    <Box className={`${styles['right-sidebar-menu-con']}`}>
      <div className={`${styles['right-sidebar-menu-box']}`}>
        <div className={`${styles['right-sidebar-menu-header']}`}>
          <h6>Partner Events & Updates</h6>
          <Avatar
            className={`${styles['close-icon']}`}
            src={CloseIcon}
            alt="close"
            onClick={toggleSlider}
          />
        </div>
        <div className={`${styles['right-sidebar-menu-body']}`}>
          <List className={`${styles.list}`}>
            {user?.view?.eventView.length === 0 ? <h6 style={{ marginTop: '20px' }}>No Updates</h6> : ''}
            {user?.view?.eventView?.map((listItem, index) => (
              <ListItem
                className={`${styles['list-item']}`}
                button
                key={index}
              >
                <Card className={`${styles['list-item-paper']}`}>
                  <ButtonMailTo link={`${listItem.link}`}>
                    <CardContent className={`${styles['list-item-paper-content']}`}>
                      <div className="row">
                        <div className={`col-12 col-sm-2 col-md-2 col-lg-2 ${styles['notification-logo']}`}>
                          <img
                            alt=""
                            src={getImage(listItem.serviceProviderView.logoView)}
                          />
                        </div>
                        <div className={`col-12 col-sm-9 col-md-9 col-lg-9 ${styles['notification-dialogue']}`}>
                          <p>{listItem.description}</p>
                          <div className={`${styles['sm-text']}`}>
                            <span className={`${styles['end-date']}`} style={{ borderRight: listItem.location && '1px solid rgb(0 0 0 / 32%)' }}>
                              {fromEpochToDateWithMonthName(listItem.endDate)}
                            </span>
                            <span className={styles.location}>
                              <strong>{listItem.location}</strong>
                            </span>
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </ButtonMailTo>
                </Card>
              </ListItem>
            ))}
          </List>
        </div>
      </div>
    </Box>
  );
  return (
    <>
      <div
        className={`${styles['notification-icon-con']}`}
        onClick={toggleSlider}
      >
        <img src="/assets/images/bell.svg" alt="" />
        {unreadCount ? <span className={`${styles['notification-count-con']}`}>{unreadCount}</span> : '' }
      </div>
      <Drawer open={notificationOpenStatus} anchor="right" onClose={toggleSlider}>
        {sideList()}
      </Drawer>
    </>
  );
}
